var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAccountAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5307 27C39.0598 27 40.5263 27.6058 41.6075 28.6841C42.6887 29.7625 43.2961 31.225 43.2961 32.75C43.2961 34.275 42.6887 35.7375 41.6075 36.8159C40.5263 37.8942 39.0598 38.5 37.5307 38.5C36.0017 38.5 34.5352 37.8942 33.454 36.8159C32.3728 35.7375 31.7654 34.275 31.7654 32.75C31.7654 31.225 32.3728 29.7625 33.454 28.6841C34.5352 27.6058 36.0017 27 37.5307 27ZM37.5307 41.375C43.9015 41.375 49.0615 43.9481 49.0615 47.125C49.0615 48.7128 47.7743 50 46.1865 50H28.875C27.2872 50 26 48.7128 26 47.125C26 43.9481 31.16 41.375 37.5307 41.375Z",
    fill: "#6B717A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAccountAvatar);
export default __webpack_public_path__ + "static/media/DefaultAccountAvatar.55b9bccc9ea0ce2696eca59c34630a5d.svg";
export { ForwardRef as ReactComponent };